import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendlyRegular from './calendly-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <CalendlyRegular {...rest} />;
}

SvgComponent.iconName = 'calendlyRegular';

export const CalendlyRegularIcon = svgIconWrapper(SvgComponent);
